import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {Guard} from './services/guard';

const routes: Routes = [
  {path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)},
  {path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule), canMatch: [Guard]},
  {path: 'avisos', loadChildren: () => import('./pages/avisos/avisos.module').then(m => m.AvisosPageModule), canMatch: [Guard]},
  {path: 'aula/:aula', loadChildren: () => import('./pages/aula/aula.module').then(m => m.AulaPageModule), canMatch: [Guard]},
  {path: 'rutinas', loadChildren: () => import('./pages/rutinas/rutinas.module').then(m => m.RutinasPageModule), canMatch: [Guard]},
  {path: 'siesta/:aula', loadChildren: () => import('./pages/siesta/siesta.module').then(m => m.SiestaPageModule), canMatch: [Guard]},
  {path: 'ajustes', loadChildren: () => import('./pages/ajustes/ajustes.module').then(m => m.AjustesPageModule), canMatch: [Guard]},
  {path: 'agenda/:id', loadChildren: () => import('./pages/agenda/agenda.module').then(m => m.AgendaPageModule), canMatch: [Guard]},
  {path: 'evento/:id', loadChildren: () => import('./pages/evento/evento.module').then(m => m.EventoPageModule), canMatch: [Guard]},
  {path: 'nota/:aula', loadChildren: () => import('./pages/nota/nota.module').then(m => m.NotaPageModule), canMatch: [Guard]},
  {path: 'ficha/:id', loadChildren: () => import('./pages/ficha/ficha.module').then(m => m.FichaPageModule), canMatch: [Guard]},
  {
    path: 'informes/:aula',
    loadChildren: () => import('./pages/informes/informes.module').then(m => m.InformesPageModule),
    canMatch: [Guard]
  }, {
    path: 'vacaciones/:aula',
    loadChildren: () => import('./pages/vacaciones/vacaciones.module').then(m => m.VacacionesPageModule),
    canMatch: [Guard]
  }, {
    path: 'entradas',
    loadChildren: () => import('./pages/entradas/entradas.module').then(m => m.EntradasPageModule),
    canMatch: [Guard]
  }, {
    path: 'notificaciones/:id',
    loadChildren: () => import('./pages/notificaciones/notificaciones.module').then(m => m.NotificacionesPageModule),
    canMatch: [Guard]
  }, {
    path: 'rutinas/:aula',
    loadChildren: () => import('./pages/rutinas/rutinas.module').then(m => m.RutinasPageModule),
    canMatch: [Guard]
  }, {
    path: 'rutina/:tipo/:aula',
    loadChildren: () => import('./pages/rutina/rutina.module').then(m => m.RutinaPageModule),
    canMatch: [Guard]
  }, {
    path: 'activarrutinas/:aula',
    loadChildren: () => import('./pages/activar-rutinas/activar-rutinas.module').then(m => m.ActivarRutinasPageModule),
    canMatch: [Guard]
  }, {
    path: 'matriculados',
    loadChildren: () => import('./pages/matriculados/matriculados.module').then(m => m.MatriculadosPageModule),
    canMatch: [Guard]
  }, {
    path: 'circular/:aula',
    loadChildren: () => import('./pages/circular/circular.module').then(m => m.CircularPageModule),
    canMatch: [Guard]
  }, {
    path: 'desbloquear',
    loadChildren: () => import('./pages/desbloquear/desbloquear.module').then(m => m.DesbloquearPageModule),
    canMatch: [Guard]
  }, {
    path: 'historico-notas/:aula',
    loadChildren: () => import('./pages/historico-notas/historico-notas.module').then(m => m.HistoricoNotasPageModule),
    canMatch: [Guard]
  }, {
    path: 'aseo/:aula',
    loadChildren: () => import('./pages/aseo/aseo.module').then(m => m.AseoPageModule),
    canMatch: [Guard]
  }, {
    path: 'calendario',
    loadChildren: () => import('./pages/calendario/calendario.module').then(m => m.CalendarioPageModule),
    canMatch: [Guard]
  }, {
    path: 'stream/:aula',
    loadChildren: () => import('./pages/stream/stream.module').then(m => m.StreamPageModule),
    canMatch: [Guard]
  }, {path: '', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
